import { Component } from '@angular/core';

@Component({
	selector: 'lvr-empty-desk',
	template: `
		<section class="empty-desk">
			<h1>Willkommen auf Ihrem Arbeitsplatz!</h1>
			<p>Sie haben aktuell keine offene Akte. Starten Sie mit einem Klienten oder einer Institution.</p>
		</section>
	`,
	styleUrl: './desk.scss',
})
export class EmptyDesk {}
